/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Save_Preset_PromptInputs */

const en_styles_save_preset_prompt = /** @type {(inputs: Styles_Save_Preset_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a preset name:`)
};

const fr_styles_save_preset_prompt = /** @type {(inputs: Styles_Save_Preset_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez entrer un nom de preset:`)
};

const de_styles_save_preset_prompt = /** @type {(inputs: Styles_Save_Preset_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie einen voreingestellten Namen ein:`)
};

const it_styles_save_preset_prompt = /** @type {(inputs: Styles_Save_Preset_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un nome predefinito:`)
};

const ru_styles_save_preset_prompt = /** @type {(inputs: Styles_Save_Preset_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, введите предустановленное имя:`)
};

const es_styles_save_preset_prompt = /** @type {(inputs: Styles_Save_Preset_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, introduzca un nombre preestablecido:`)
};

const zh_cn2_styles_save_preset_prompt = /** @type {(inputs: Styles_Save_Preset_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入预设名称：`)
};

const ja_styles_save_preset_prompt = /** @type {(inputs: Styles_Save_Preset_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセット名を入力してください:`)
};

const hi_styles_save_preset_prompt = /** @type {(inputs: Styles_Save_Preset_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया एक पूर्व निर्धारित नाम दर्ज करें:`)
};

const pt_pt2_styles_save_preset_prompt = /** @type {(inputs: Styles_Save_Preset_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, insira um nome predefinido:`)
};

/**
* | output |
* | --- |
* | "Please enter a preset name:" |
*
* @param {Styles_Save_Preset_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_save_preset_prompt = /** @type {((inputs?: Styles_Save_Preset_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Save_Preset_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_save_preset_prompt(inputs)
	if (locale === "de") return de_styles_save_preset_prompt(inputs)
	if (locale === "it") return it_styles_save_preset_prompt(inputs)
	if (locale === "ru") return ru_styles_save_preset_prompt(inputs)
	if (locale === "es") return es_styles_save_preset_prompt(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_save_preset_prompt(inputs)
	if (locale === "ja") return ja_styles_save_preset_prompt(inputs)
	if (locale === "hi") return hi_styles_save_preset_prompt(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_save_preset_prompt(inputs)
	return en_styles_save_preset_prompt(inputs)
});